import { useNavigate } from "react-router-dom";
import { fmtBRL, fmtPct } from "@/lib/format";
import { EmptyState } from "@/components/common/StateViews";
import { cn } from "@/lib/utils";

const MEDAL = ["text-[hsl(var(--secondary))]", "text-slate-300", "text-amber-700"];

export function RankingList({ rows = [] }) {
  const navigate = useNavigate();
  if (!rows.length) return <EmptyState message="Sem vendedores no período." />;

  const max = Math.max(...rows.map((r) => r.receita), 1);

  return (
    <div className="space-y-2" data-testid="ranking-list">
      {rows.map((r) => (
        <button
          key={r.salesperson_id}
          data-testid={`ranking-item-${r.salesperson_id}`}
          onClick={() => navigate(`/raiox/${r.salesperson_id}`)}
          className="group w-full rounded-md border border-border bg-background/40 p-3 text-left transition-colors hover:border-primary/50 hover:bg-accent"
        >
          <div className="flex items-center gap-3">
            <span
              className={cn(
                "flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-border font-num text-xs font-bold",
                r.posicao <= 3 ? MEDAL[r.posicao - 1] : "text-muted-foreground"
              )}
            >
              {r.posicao}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-2">
                <span className="truncate text-sm font-medium text-foreground">
                  {r.name}
                </span>
                <span className="font-num text-sm text-foreground">
                  {fmtBRL(r.receita)}
                </span>
              </div>
              <div className="mt-1.5 flex items-center gap-2">
                <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-muted">
                  <div
                    className="h-full rounded-full bg-primary transition-all"
                    style={{ width: `${(r.receita / max) * 100}%` }}
                  />
                </div>
                <span className="w-14 shrink-0 text-right font-num text-xs text-muted-foreground">
                  {fmtPct(r.atingimento)}
                </span>
              </div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
